import React, { useState } from "react";
import { motion } from "framer-motion";

const examples = {
  functions: [
    {
      name: "sayHello",
      code: `func sayHello() {
  fmt.Println("Привет, мир!")
}`,
      run: () => "Привет, мир!"
    },
    {
      name: "add",
      code: `func add(a int, b int) int {
  return a + b
}`,
      run: () => {
        const a = 5, b = 3;
        return `add(5, 3) = ${a + b}`;
      }
    }
  ],
  methods: [
    {
      name: "Person.greet",
      code: `type Person struct { name string; age int }

func (p Person) greet() {
  fmt.Printf("Привет, меня зовут %s и мне %d лет.\n", p.name, p.age)
}`,
      run: () => `Привет, меня зовут Алекс и мне 29 лет.`
    },
    {
      name: "Point.move",
      code: `type Point struct { x, y int }

func (p *Point) move(dx int, dy int) {
  p.x += dx
  p.y += dy
}`,
      run: () => `Point(1,2) moved by (3,4) → (4,6)`
    }
  ]
};

const FunctionMethodDemo = () => {
  const [tab, setTab] = useState("functions");
  const [selected, setSelected] = useState(examples.functions[0]);
  const [output, setOutput] = useState("");

  const handleRun = () => {
    setOutput(selected.run());
  };

  const list = examples[tab];

  return (
    <div style={styles.container}>
      <h3 style={styles.header}>Интерактив: Функции и Методы в Go</h3>
      <div style={styles.tabs}>
        <button onClick={() => { setTab("functions"); setSelected(examples.functions[0]); setOutput(""); }}
          style={tab === "functions" ? styles.activeTab : styles.tab}>
          Функции
        </button>
        <button onClick={() => { setTab("methods"); setSelected(examples.methods[0]); setOutput(""); }}
          style={tab === "methods" ? styles.activeTab : styles.tab}>
          Методы
        </button>
      </div>

      <div style={styles.selector}>
        <label style={styles.label}>Выберите пример:</label>
        <select
          value={selected.name}
          onChange={e => {
            const ex = list.find(x => x.name === e.target.value);
            setSelected(ex);
            setOutput("");
          }}
          style={styles.select}
        >
          {list.map(ex => (
            <option key={ex.name} value={ex.name}>{ex.name}</option>
          ))}
        </select>
      </div>

      <pre style={styles.codeBlock}>
        <code>{selected.code}</code>
      </pre>

      <button onClick={handleRun} style={styles.runButton}>Запустить</button>

      <motion.div
        style={styles.output}
        initial={{ opacity: 0 }}
        animate={{ opacity: output ? 1 : 0 }}
      >
        {output}
      </motion.div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '700px',
    margin: '2rem auto',
    padding: '1rem',
    background: '#fff',
    borderRadius: '1rem',
    border: '2px solid black',
  },
  header: {
    textAlign: 'center',
    marginBottom: '1rem'
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
    marginBottom: '1rem'
  },
  tab: {
    padding: '0.5rem 1rem',
    background: '#e0e0e0',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer'
  },
  activeTab: {
    padding: '0.5rem 1rem',
    background: 'black',
    color: '#fff',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace'
  },
  selector: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem'
  },
  label: {
    fontWeight: 'bold'
  },
  select: {
    padding: '0.4rem',
    border: '1px solid #ccc',
    borderRadius: '0.4rem'
  },
  codeBlock: {
    background: '#f5f5f5',
    padding: '1rem',
    borderRadius: '0.5rem',
    overflowX: 'auto'
  },
  runButton: {
    marginTop: '1rem',
    padding: '0.5rem 1rem',
    background: 'black',
    color: 'white',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontFamily: 'Roboto, monospace'
  },
  output: {
    marginTop: '1rem',
    padding: '0.75rem',
    background: '#f5f5f5',
    borderRadius: '0.5rem',
    minHeight: '2rem',
    fontFamily: 'monospace'
  }
};

export default FunctionMethodDemo;